import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface Entregador {
    id: number
    nome: string
    telefone: string
    placaVeiculo: string | null
    ativo: boolean
    estabelecimentoNome: string | null
}

export interface SalvarEntregadorPayload {
    id: number | null
    nome: string
    telefone: string
    placaVeiculo: string
    ativo: boolean
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

function erroParaRespostaRaw(error: unknown): RespostaErroRaw {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (isErroBackend(data)) {
        return { codErro: data.codErro, mensagem: data.mensagem }
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

export const listarEntregadores = async function (
    authorization: string
): Promise<Entregador[] | ErroApi> {
    try {
        const response = await api
            .get<Entregador[] | RespostaErroRaw>("entregador/listar", {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as Entregador[]
    } catch (error) {
        RegistrarLogErro(error, "ListarEntregadores", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const salvarEntregador = async function (
    authorization: string,
    payload: SalvarEntregadorPayload
): Promise<Entregador | ErroApi> {
    try {
        const response = await api
            .post<Entregador | RespostaErroRaw>("entregador/salvar", payload, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        return response.data as Entregador
    } catch (error) {
        RegistrarLogErro(error, "SalvarEntregador", JSON.stringify(payload))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const inativarEntregador = async function (
    authorization: string,
    id: number
): Promise<void | ErroApi> {
    try {
        const response = await api
            .delete<RespostaErroRaw | null>(`entregador/inativar/${id}`, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (response.data && isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
    } catch (error) {
        RegistrarLogErro(error, "InativarEntregador", String(id))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
